import { render, staticRenderFns } from "./ProductsBaseView.vue?vue&type=template&id=9634ebda"
import script from "./ProductsBaseView.vue?vue&type=script&lang=js"
export * from "./ProductsBaseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports